const PENDING_INVITE_TOKEN_KEY = "pendingInviteToken";
const PENDING_INVITE_TOKEN_TTL = 60 * 60 * 1000;

export function savePendingInviteToken(token) {
  try {
    localStorage.setItem(PENDING_INVITE_TOKEN_KEY, JSON.stringify({
      token,
      expiresAt: Date.now() + PENDING_INVITE_TOKEN_TTL,
    }));
  } catch {
    // Storage can be unavailable in private browsers; the redirect still carries the token.
  }
}

export function getPendingInviteToken() {
  try {
    const pendingInvite = JSON.parse(localStorage.getItem(PENDING_INVITE_TOKEN_KEY));
    if (!pendingInvite || !pendingInvite.token || pendingInvite.expiresAt <= Date.now()) {
      localStorage.removeItem(PENDING_INVITE_TOKEN_KEY);
      return null;
    }
    return pendingInvite.token;
  } catch {
    return null;
  }
}

export function clearPendingInviteToken() {
  try {
    localStorage.removeItem(PENDING_INVITE_TOKEN_KEY);
  } catch {
    // Storage can be unavailable in private browsers.
  }
}

export async function resolvePostAuthRoute(store, fallbackRoute) {
  const pendingInviteToken = getPendingInviteToken();
  if (pendingInviteToken) {
    return `/invite/${encodeURIComponent(pendingInviteToken)}?accept=1`;
  }

  return fallbackRoute;
}
